const PROMO = {
  GET_ALL_DELIVERY_MODE: "GET_ALL_DELIVERY_MODE",
  FILTER_DELIVERY_MODE: "FILTER_DELIVERY_MODE",
  FILTER_PROMO_NOPAGE: "FILTER_PROMO_NOPAGE",
  SEARCH_DELIVERY_MODE: "SEARCH_DELIVERY_MODE",
  STORE_DELIVERY_MODE: "STORE_DELIVERY_MODE",
  SHOW_DELIVERY_MODE: "SHOW_DELIVERY_MODE",
  EDIT_PROMO: "EDIT_PROMO",
  DELETE_PROMO: "DELETE_PROMO",
  LOADING_DELIVERY_MODE: "LOADING_DELIVERY_MODE",
  LOADING_SEARCH: "LOADING_SEARCH",
  DELETING: "DELETING",
  FILTERING: "FILTERING",
};

export default PROMO;
